import { render, staticRenderFns } from "./PostType.vue?vue&type=template&id=72a2ea36&scoped=true"
import script from "./PostType.vue?vue&type=script&lang=ts"
export * from "./PostType.vue?vue&type=script&lang=ts"
import style0 from "./PostType.vue?vue&type=style&index=0&id=72a2ea36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a2ea36",
  null
  
)

export default component.exports